export const isHouseholdMemberPhotoResponse = (value) => {
    if (!value || typeof value !== 'object' || !('photo' in value))
        return false;
    const photo = value.photo;
    return (photo === null ||
        (typeof photo.id === 'string' &&
            typeof photo.householdMemberId === 'string' &&
            typeof photo.thumbnailUrl === 'string' &&
            typeof photo.originalUrl === 'string' &&
            photo.status === 'active'));
};
